import type { PresencaStatus } from '../types';

// Avatar de 38px: roxo claro com a inicial; vira ✓ verde quando confirmada.
export function AvatarPessoa({
  nome,
  confirmada,
}: {
  nome: string;
  confirmada: boolean;
}) {
  const inicial = nome.trim().charAt(0).toUpperCase() || '?';

  if (confirmada) {
    return (
      <span className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full bg-green-600 text-white">
        <i className="ri-check-line text-lg" />
      </span>
    );
  }

  return (
    <span className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full bg-primary-100 text-base font-semibold text-primary-700">
      {inicial}
    </span>
  );
}

const ESTADOS: Record<PresencaStatus, { rotulo: string; classes: string }> = {
  confirmada: { rotulo: 'Confirmada', classes: 'bg-green-50 text-green-700' },
  aguardando: { rotulo: 'Aguardando', classes: 'bg-amber-100 text-amber-800' },
  recusada: { rotulo: 'Recusada', classes: 'bg-red-50 text-red-700' },
  nenhuma: { rotulo: 'Falta', classes: 'bg-secondary-100 text-secondary-500' },
};

// Pastilha de estado (11px). Vermelho só para "recusada".
export function PilhaEstado({ presenca }: { presenca: PresencaStatus }) {
  const estado = ESTADOS[presenca];
  return (
    <span
      className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${estado.classes}`}
    >
      {estado.rotulo}
    </span>
  );
}